<template>
  <div>
    <v-card
      flat
      outlined
      rounded
      :dark="darkMode"
      class="on-duty-notification d-flex flex-column justify-center"
      max-width="420"
      style="border-radius: 14px !important"
    >
      <!-- Title bar with date and duty name -->
      <div :class="`${config.headerBgColor[themeName]} ${color}--text`" class="d-flex py-4 align-center" @click="navigateToDuty">
        <div class="ml-4 mr-7 d-flex">
          <div class="d-flex op-text-xl">
            {{ dateShort }}
          </div>
          <div class="d-flex op-text-xl" v-if="duty">, {{ $t('myDuty.title') }} {{ duty.dutyname }}</div>
        </div>
        <v-btn icon class="justify-end pr-2">
          <v-icon :color="color">mdi-arrow-right</v-icon>
        </v-btn>
      </div>

      <div class="d-flex op-text-xl mt-4 ml-4" v-if="duty">{{ $t('myDuty.title') }} {{ duty.dutyname }}</div>
      <duty-card-content v-if="duty" class="my-4 ml-4" style="min-height: 60px" :showDate="false" :duty="duty"></duty-card-content>
      <div v-else class="ml-4 op-text" style="height: 60px">{{ $t('myDuty.noDutyAtDay') }}</div>
      <div class="d-flex justify-end mr-4 mt-1 op-text">
        {{ $t('widget.onduty.status') }}:
        {{ lastSyncDateTime ? lastSyncDateTimeFormatted : $t('widget.onduty.currently_syncronizing') }}
      </div>
      <v-divider></v-divider>
      <v-card-actions class="flex-wrap justify-start">
        <a class="mt-5 ml-2 chip op-text-m primary elevation-1 no-underline" :class="`${color}--text`" v-if="duty" :href="`tel:${phoneNumber}`" color="primary">
          {{ $t('widget.onduty.report') }}
          <v-icon right :color="color" dark> mdi-phone </v-icon>
        </a>
      </v-card-actions>
    </v-card>
    <div class="mt-5 op-text chip background elevation-1" :class="`${theme.elements.btnColor}--text`" @click="openWelcomeDialog">
      {{ $t('welcome.button.show_message') }}
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateUtils from '@/common/dateUtils';
import DutyCardContent from '@/modules/myDuties/components/DutyCardContent.vue';
import { mapState } from 'vuex';

export default {
  name: 'OnDutyNotification',
  mixins: [common, configMixin],
  props: {
    config: {
      type: Object,
    },
  },
  components: {
    DutyCardContent,
  },

  computed: {
    duty() {
      // console.debug('calculate duty');
      let today = new Date();
      return this.duties.find((d) => {
        let date = new Date(Date.parse(d.day));
        return dateUtils.isSameDate(today, date);
      });
    },
    ...mapState({
      duties: (state) => state.meinDienst.duties,
    }),

    lastSyncDateTime() {
      return this.$store.state.sync.lastSyncDateTime;
    },
    phoneNumber() {
      return this.features.indienstPhoneNumber;
    },

    color() {
      return this.config.headerFgColor[this.themeName];
    },

    date() {
      return new Date();
    },
    dateShort() {
      return this.duty && this.duty.day
        ? dateUtils.formatAsLocaleNamedShortDate(dateUtils.parseISOString(this.duty.day), this.locale)
        : dateUtils.formatAsLocaleNamedShortDate(new Date(), this.locale);
    },
    backgroundClasses() {
      return this.config.background ? this.config.background[this.darkMode ? 'dark' : 'light'] : '';
    },
    lastSyncDateTimeFormatted() {
      console.log('lastSyncDateTime', this.lastSyncDateTime);
      return this.lastSyncDateTime ? dateUtils.formatAsLocaleShortDateTime(new Date(this.lastSyncDateTime)) : '';
    },
  },
  methods: {
    navigateToDuty() {
      if (this.duty) {
        this.$router.push(`/myduties/detail/${this.duty.id}`);
      } else {
        this.$router.push(`/myduties`);
      }
    },
    openWelcomeDialog() {
      console.debug('openWelcomeDialog');

      this.$store.commit('welcome/setShowWelcome', true);
      this.$store.commit('welcome/setIsWelcomeDialogVisible', true);
    },
  },
};
</script>
